import { useContext } from 'react';
import { ClinicFilterContext } from '../contexts/ClinicFilterContext';

export const useClinicFilterContext = () => {
  return useContext(ClinicFilterContext);
};
